import React, {useEffect, useState} from "react";
import { InputNumber } from 'primereact/inputnumber';
import {Field} from "formik";

export default function NsFieldNumber({
                                    name,
                                    placeholder = '',
                                    formikRef,
                                    onChange = () => {},
                                    values = [],
                                    step = 1,
                                    valMaxNumeric = 999999999999999,
                                    maxFractionDigits = 0,
                                    readOnly = false,
                                    isDisabled = false,
                                    isRequired = false,
                                    useGrouping = false,
                                    validate = () => {},
                                    valoreNoFormik,
                                    showButtons = false,
                                    isFormFieldInvalid = false,
                                }) {


    const [valNum, setValNum] = useState();

    useEffect(() => {
        setValNum((formikRef && values[name]) ? (values[name] !== '' ? values[name] : null) : (valoreNoFormik && valoreNoFormik !== '' ? valoreNoFormik : null));
    }, [formikRef, values[name], valoreNoFormik]);

    return (
        formikRef && typeof formikRef !== "undefined" ?
            <Field
                name={name}
                component={InputNumber}
                className="w-100"
                pt={{input: () => ({root: {className: 'w-100'}})}}
                onValueChange={(e) => {
                    if (formikRef) {
                        let newVal = e.value !== null ? e.value : '';
                        formikRef.current.setFieldValue(name, newVal);
                    }
                    onChange(e);
                }}
                allowEmpty={true}
                step={step}
                maxFractionDigits={maxFractionDigits}
                max={valMaxNumeric}
                useGrouping={useGrouping}
                readOnly={readOnly}
                disabled={isDisabled}
                required={isRequired}
                // se sono nel contesto di formik utilizzo i suoi valori, se no quello passato come prop
                value={valNum}
                placeholder={placeholder}
                validate={validate}
                invalid={isFormFieldInvalid()}
                showButtons={showButtons}
            />
            :
        <InputNumber
            name={name}
            className="w-100"
            pt={{input: () => ({root: {className: 'w-100'}})}}
            onValueChange={onChange}
            allowEmpty={true}
            step={step}
            maxFractionDigits={maxFractionDigits}
            max={valMaxNumeric}
            useGrouping={useGrouping}
            readOnly={readOnly}
            disabled={isDisabled}
            required={isRequired}
            // se sono nel contesto di formik utilizzo i suoi valori, se no quello passato come prop
            value={valNum}
            placeholder={placeholder}
            invalid={isFormFieldInvalid()}
            showButtons={showButtons}
        />
    );
}